import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteExecutiveSummaryFileContent: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/nominations/${nominationId}/executive-summary-file-content`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete executive summary file content'));
